var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "216 42 346 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M596.75,376.62c0-4.63-1.46-7.12-6.47-7.12-5.74,0-9.39,2.05-11.67,5v33H562.47V357.39h16.14v3.3a21.35,21.35,0,0,1,12.95-4.28c14.31,0,21.33,7.48,21.33,18.52v32.59H596.75Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M666.13,402.36c-6.83,4.72-14.49,6.14-22.42,6.14C630,408.5,617,402.71,617,383.12c0-18.34,10.21-26.8,25.44-26.8,16.41,0,24.71,10.24,24.71,26.54,0,1.69-.09,3.2-.19,4.89H633.4c1.37,5.61,4.93,7.93,11,7.93A31.42,31.42,0,0,0,661,391.4Zm-15.5-27c-1.18-4.37-3.82-6.24-8.47-6.24s-7.39,1.87-8.58,6.24Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M688.74,395.86c5.93,0,9.39-.27,9.39-2.85s-5-3.56-10.85-5.43c-11.21-3.57-18.23-8.37-18.23-16.3,0-10,6.56-14.87,22.61-14.87,7.39,0,15.59,1.78,20.33,4.36l-4.65,12.29c-4.47-1.87-9.66-4-15.13-4s-6.93.53-6.93,2.22c0,2.58,4.92,3.83,10.76,5.52,10.21,3.12,18.23,6.23,18.23,16.12,0,11.4-10,15.67-26.07,15.67-8.12,0-15.59-1.69-20.7-5.17l4.92-12.1C679,395.14,683.64,395.86,688.74,395.86Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M739.34,369.68v22.26c0,2.49.55,3.38,3,3.38a59,59,0,0,0,9.48-.62l1.37,12c-3.65,1.42-12.49,1.87-15.14,1.87-11.12-.27-14.86-5.34-14.86-14.6V369.68h-8.84V356.5h8.84V345h16.14V356.5h11.95v13.18Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M751.83,382.5c0-17.45,10.58-26.18,27-26.18s27,8.73,27,26.18-10.58,26.09-27,26.09S751.83,399.86,751.83,382.5Zm37.75,0c0-8.81-3.56-13.18-10.76-13.18s-10.76,4.37-10.76,13.18,3.56,13.09,10.76,13.09S789.58,391.23,789.58,382.5Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M807.26,382.5c0-18.79,11.4-26.18,28.63-26.18,5.83,0,13.58,1.78,17.6,4L849.75,373a32.2,32.2,0,0,0-13.86-3.38c-8.75,0-12.4,3.29-12.4,12.91s3.65,12.82,12.31,12.82c3.92,0,10-1.6,14.68-3.56l3.1,12.91a52.31,52.31,0,0,1-19.15,3.92C818.66,408.59,807.26,401.29,807.26,382.5Z",
    transform: "translate(-345.25 -293.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6f00",
    d: "M872.63,388.2v19.32h-16V336.29h16v34.28l13.13-13.18H906l-22.88,21.73,22.7,28.4H887.31Z",
    transform: "translate(-345.25 -293.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aff4e014661c76ba99c30c2b7da085e0.svg";
export { ForwardRef as ReactComponent };